<template>
  <div id="tac-admin-sales-report-sales-by-state">
    <router-view />
    <vue-progress-bar></vue-progress-bar>
  </div><!-- #tac-admin-sales-report-sales-by-state -->
</template>

<script>
import AuthMixin from '@/plugin/mixin/auth'

export default {
  mixins: [
    AuthMixin
  ]
}
</script>
